/* INTEGY V568/V578 — consolidated collection state owner.
   Owns stock mode, scale verification, collection-navigation stock defaults,
   filter-link state preservation, direct-commerce accessibility recovery,
   and stale deep-page repair. Replaces V556 collection-state runtime. */
(function () {
  'use strict';
  if (window.IntegyV568CollectionState) return;

  var root = document.documentElement;
  var navScope = '[data-site-navigation], [data-mobile-menu], .site-mobile-nav, .mobile-menu, .site-header';
  var filterLinkSelector = [
    '[data-integy-v353-static-filter-row]',
    '[data-integy-v247-direct-nav]',
    '[data-integy-v439-direct-filter]',
    '.integy-v27-active-filter-pill',
    '.integy-v27-clear-filters'
  ].join(',');


  /* V564: canonicalize legacy /collections/all/<filter> URLs to the indexed master
     catalog when every tag is a known buyer-facing facet. This fixes legacy routes
     such as /collections/all/hub-carrier: V501 can then provide accurate zero-result
     suppression and single-select Part Type / Scale / Color behavior while Shopify's
     native availability parameter remains the live stock authority. */
  var legacyCanonicalHandles = (function () {
    var list = [
      'brace','bumper','skid-plate','body-mount','body','chassis-plate','tie-rod','rod-end','ball-end','ball-link','linkage',
      'servo-horn','servo','receiver-box','turnbuckle','suspension-link','suspension-arm','shock-shaft','shock-tool','shock','shock-tower',
      'hub-carrier','caster-block','steering-block','bearing','gear','pinion-gear','spur-gear','gearbox','differential','drive-shaft',
      'esc','receiver','radio-controller','motor','gyro','cooling-fan','led-light','connector','battery-meter','discharger','charger-accessory',
      'power-supply','starter-box','weight-scale','steering-wheel','wheel-hex','wheel','tire','premounted-set','foam-insert','wheel-nut',
      'wheel-accessory','hex-wrench','nut-driver','screwdriver','body-reamer','setup-station','tool-set','turnbuckle-tool','wheel-nut-wrench',
      'cutting-tool','soldering-tool','pit-tool','tool-bag','oil-fluid','adhesive-tape','motor-tool','stand','spring','axle',
      '2wd','4wd','6x6','8x8','buggy','truggy','short-course','monster-truck','crawler','drift','touring','f1','m-chassis','micro-mini','rtr','artr','kit','truck','semi-truck',
      'black','blue','green','grey','gray','gunmetal','orange','purple','red','silver','yellow','chrome','gold','bronze','light-blue','dark-green',
      'sale','on-sale','clearance','discount','scratch-dent','open-box',
      '1-4','1-5','1-6','1-7','1-8','1-10','1-12','1-14','1-16','1-18','1-24','1-28','1-36'
    ];
    var map = Object.create(null);
    list.forEach(function (handle) { map[handle] = true; });
    return map;
  }());

  function handleize(value) {
    return String(value == null ? '' : value).toLowerCase().trim()
      .replace(/&/g, ' and ').replace(/['\u2019]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }

  function v626RootPath() {
    try {
      var rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      if (rootPath) return rootPath.charAt(rootPath.length - 1) === '/' ? rootPath : rootPath + '/';
    } catch (error) {}
    return '/';
  }

  function v626LocalizedPath(path) {
    return v626RootPath() + String(path || '').replace(/^\/+/, '');
  }

  function canonicalizeLegacyAllRoute() {
    var path = String(location.pathname || '');
    var url;
    try { url = new URL(location.href); } catch (error) { return false; }
    /* V568: bare /collections/all stays native. Legacy /collections/all/<facet> rescue remains below. */

    var match = path.match(/^\/collections\/all\/([^/?#]+)\/?$/i);
    if (!match) return false;
    var tags = decodeURIComponent(match[1]).split('+').map(handleize).filter(Boolean);
    if (!tags.length || !tags.every(function (tag) { return !!legacyCanonicalHandles[tag]; })) return false;
    url.pathname = v626LocalizedPath('collections/all-integy-hop-up-parts');
    url.searchParams.delete('page');
    url.searchParams.delete('integy_filters');
    url.searchParams.delete('integy_tag_filter');
    url.searchParams.set('integy_filter', tags.join('+'));
    // V577: the canonical master-hopups route is an indexed-stock owner.
    // Never hand it back to native filter.v.availability here.
    var nativeStock = url.searchParams.get('filter.v.availability') || '';
    var customStock = url.searchParams.get('integy_stock') || '';
    var desiredStock = nativeStock === '0' ? 'out' : nativeStock === '1' ? 'in' : (customStock === 'out' || customStock === 'all' ? customStock : 'in');
    url.searchParams.delete('filter.v.availability');
    url.searchParams.set('integy_stock', desiredStock);
    window.IntegyV565LegacyRedirecting = true;
    window.IntegyV564LegacyRedirecting = true;
    root.classList.add('integy-v567-legacy-route-redirect');
    location.replace(urlString(url));
    return true;
  }

  function qa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }

  function isCollection() {
    return !!(document.body && document.body.classList.contains('template-collection'));
  }

  function here() {
    try { return new URL(location.href); }
    catch (error) { return null; }
  }

  function urlString(url) {
    return url.pathname + (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') + url.hash;
  }

  function indexedStockOwner(url) {
    try {
      var target = url || here();
      if (!target) return false;
      var handle = (String(target.pathname || '').split('/').filter(Boolean)[1] || '').toLowerCase();
      return /^(?:all|all-integy-hop-up-parts|hopups-for-traxxas|hop-up-parts-for-traxxas|parts-for-traxxas)$/.test(handle);
    } catch (error) { return false; }
  }

  function clearanceCustomStockOwner(url) {
    try {
      var target = url || here();
      if (!target) return false;
      var handle = (String(target.pathname || '').split('/').filter(Boolean)[1] || '').toLowerCase();
      return handle === 'on-sale-clearance-up-to-80';
    } catch (error) { return false; }
  }

  function normalizeStockUrl() {
    if (!isCollection()) return;
    var url = here();
    if (!url) return;
    var availability = url.searchParams.get('filter.v.availability');
    var stock = url.searchParams.get('integy_stock');
    var changed = false;

    /* V680: Clearance is owned by the V677 large-stock/index renderer in In/Out
       modes. Keep all three stock modes on integy_stock so native availability
       cannot race or contaminate that owner. */
    if (clearanceCustomStockOwner(url)) {
      var clearanceDesired = availability === '0' ? 'out' : availability === '1' ? 'in' : (stock === 'out' || stock === 'all' ? stock : 'in');
      if (url.searchParams.has('filter.v.availability')) { url.searchParams.delete('filter.v.availability'); changed = true; }
      if (url.searchParams.has('integy_include_sold_out')) { url.searchParams.delete('integy_include_sold_out'); changed = true; }
      if (url.searchParams.get('integy_stock') !== clearanceDesired) { url.searchParams.set('integy_stock', clearanceDesired); changed = true; }
      if (changed) history.replaceState(history.state, '', urlString(url));
      return;
    }

    /* V578: the three audited indexed-stock universes must never be normalized
       back to Shopify's native availability parameter. Preserve one owner from
       first paint through every deferred collection-state pass. */
    if (indexedStockOwner(url)) {
      var desired = availability === '0' ? 'out' : availability === '1' ? 'in' : (stock === 'out' || stock === 'all' ? stock : 'in');
      if (url.searchParams.has('filter.v.availability')) { url.searchParams.delete('filter.v.availability'); changed = true; }
      if (url.searchParams.has('integy_include_sold_out')) { url.searchParams.delete('integy_include_sold_out'); changed = true; }
      if (url.searchParams.get('integy_stock') !== desired) { url.searchParams.set('integy_stock', desired); changed = true; }
      if (changed) history.replaceState(history.state, '', urlString(url));
      return;
    }

    if ((availability === '1' || availability === '0') && stock && stock !== 'all') {
      url.searchParams.delete('integy_stock');
      changed = true;
    }
    if (availability && availability !== '0' && availability !== '1') {
      url.searchParams.delete('filter.v.availability');
      changed = true;
    }
    if (changed) history.replaceState(history.state, '', urlString(url));
  }

  function mode() {
    var url = here();
    if (!url) return 'in';
    var availability = url.searchParams.get('filter.v.availability') || '';
    var stock = url.searchParams.get('integy_stock') || '';
    if (stock === 'all') return 'all';
    if (availability === '0' || stock === 'out') return 'out';
    return 'in';
  }

  function stockUrl(nextMode) {
    var url = here();
    if (!url) return null;
    url.searchParams.delete('page');
    url.searchParams.delete('integy_include_sold_out');

    /* V680: Clearance uses a custom stock URL for all modes so its V677
       large-stock/index owner never shares state with Shopify native availability. */
    if (clearanceCustomStockOwner(url)) {
      url.searchParams.delete('filter.v.availability');
      url.searchParams.set('integy_stock', nextMode === 'out' ? 'out' : nextMode === 'all' ? 'all' : 'in');
      return url;
    }

    /* V578: indexed-stock collections navigate directly to their canonical
       stock state. This removes the V568 native-availability detour that caused
       one unnecessary Shopify page load before V577 could normalize the URL. */
    if (indexedStockOwner(url)) {
      url.searchParams.delete('filter.v.availability');
      url.searchParams.set('integy_stock', nextMode === 'out' ? 'out' : nextMode === 'all' ? 'all' : 'in');
      return url;
    }

    url.searchParams.delete('integy_stock');
    if (nextMode === 'out') url.searchParams.set('filter.v.availability', '0');
    else if (nextMode === 'all') {
      url.searchParams.delete('filter.v.availability');
      url.searchParams.set('integy_stock', 'all');
    } else url.searchParams.set('filter.v.availability', '1');
    return url;
  }

  function syncStock() {
    if (!isCollection()) return;
    var currentMode = mode();
    ['in','out','all'].forEach(function (name) {
      root.classList.remove('integy-v558-stock-' + name);
      root.classList.remove('integy-v556-stock-' + name);
    });
    root.classList.add('integy-v558-stock-' + currentMode, 'integy-v556-stock-' + currentMode);
    qa('[data-integy-v449-stock-mode]').forEach(function (button) {
      var on = button.getAttribute('data-integy-v449-stock-mode') === currentMode;
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.classList.toggle('is-active', on);
      button.setAttribute('data-integy-v558-stock-owned', 'true');
    });
    qa('[data-integy-v449-stock-toggle]').forEach(function (group) {
      group.setAttribute('data-integy-v558-stock-mode', currentMode);
    });
  }

  function stockClick(event) {
    if (!isCollection()) return;
    var button = event.target && event.target.closest ? event.target.closest('[data-integy-v449-stock-mode]') : null;
    if (!button) return;
    var nextMode = button.getAttribute('data-integy-v449-stock-mode');
    if (!/^(?:in|out|all)$/.test(nextMode)) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    if (nextMode === mode()) { syncStock(); return; }
    try {
      if (window.IntegyV545NavigationState && typeof window.IntegyV545NavigationState.snapshot === 'function') {
        window.IntegyV545NavigationState.snapshot();
      }
    } catch (error) {}
    var url = stockUrl(nextMode);
    if (!url) return;
    root.classList.add('integy-v558-stock-navigating', 'integy-v556-stock-navigating');
    location.assign(urlString(url));
  }

  function scaleHandle(anchor) {
    var handle = (anchor.getAttribute('data-tag-handle') || '').toLowerCase();
    if (/^1-(?:4|5|6|7|8|10|12|14|16|18|24|28|36)$/.test(handle)) return handle;
    try {
      var url = new URL(anchor.href, location.origin);
      var filter = url.searchParams.get('integy_filter') || '';
      var match = filter.match(/(?:^|\+)(1-(?:4|5|6|7|8|10|12|14|16|18|24|28|36))(?:\+|$)/);
      return match ? match[1] : '';
    } catch (error) { return ''; }
  }

  function scaleSweep() {
    if (!isCollection()) return;
    var seen = {};
    qa('a[data-tag-handle],a.integy-v27-filter-chip').forEach(function (anchor) {
      var scale = scaleHandle(anchor);
      if (!scale) return;
      seen[scale] = 1;
      anchor.setAttribute('data-integy-v558-scale-verified', 'true');
    });
    root.setAttribute('data-integy-v558-scale-count', String(Object.keys(seen).length));
  }

  function collectionUrl(href) {
    try {
      var url = new URL(href, location.origin);
      if (url.origin !== location.origin || !/^\/collections\/[^/]+\/?$/.test(url.pathname)) return null;
      var handle = (url.pathname.split('/').filter(Boolean)[1] || '').toLowerCase();
      var indexedStock = /^(?:all|all-integy-hop-up-parts|hopups-for-traxxas|hop-up-parts-for-traxxas|parts-for-traxxas)$/.test(handle);
      var clearanceStock = handle === 'on-sale-clearance-up-to-80';
      if (clearanceStock) {
        var clearanceNative = url.searchParams.get('filter.v.availability') || '';
        var clearanceCustom = url.searchParams.get('integy_stock') || '';
        var clearanceMode = clearanceNative === '0' ? 'out' : clearanceNative === '1' ? 'in' : (clearanceCustom === 'out' || clearanceCustom === 'all' ? clearanceCustom : 'in');
        url.searchParams.delete('filter.v.availability');
        url.searchParams.delete('page');
        url.searchParams.set('integy_stock', clearanceMode);
        return url;
      }
      if (indexedStock) {
        var native = url.searchParams.get('filter.v.availability') || '';
        var custom = url.searchParams.get('integy_stock') || '';
        var mode = native === '0' ? 'out' : native === '1' ? 'in' : (custom === 'out' || custom === 'all' ? custom : 'in');
        url.searchParams.delete('filter.v.availability');
        url.searchParams.delete('page');
        url.searchParams.set('integy_stock', mode);
        return url;
      }
      if (url.searchParams.get('integy_stock') === 'all' || /^[01]$/.test(url.searchParams.get('filter.v.availability') || '')) return url;
      url.searchParams.delete('page');
      url.searchParams.set('filter.v.availability', '1');
      return url;
    } catch (error) { return null; }
  }

  function normalizeLink(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    var raw = anchor.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^javascript:/i.test(raw)) return;
    var url = collectionUrl(raw);
    if (!url) return;
    anchor.setAttribute('href', urlString(url));
    anchor.setAttribute('data-integy-v558-native-stock-link', 'true');
  }

  function normalizeNav(scope) {
    var roots = [];
    if (scope && scope.matches && scope.matches(navScope)) roots.push(scope);
    if (scope && scope.querySelectorAll) roots = roots.concat(qa(navScope, scope));
    if (!roots.length && scope === document) roots = qa(navScope);
    roots.forEach(function (node) { qa('a[href*="/collections/"]', node).forEach(normalizeLink); });
  }

  /* Preserve the buyer's stock/sort/view state when a static tag/filter link changes
     the collection path or integy_filter value. V556 left these links bare, which could
     make a selected vehicle + Blue filter appear to lose stock/sort state. */
  function normalizeFilterLink(anchor) {
    if (!isCollection() || !anchor || !anchor.getAttribute) return;
    var raw = anchor.getAttribute('href');
    if (!raw || raw.charAt(0) === '#' || /^javascript:/i.test(raw)) return;
    var current = here();
    if (!current) return;
    try {
      var target = new URL(raw, location.origin);
      if (target.origin !== location.origin || target.pathname.indexOf('/collections/') !== 0) return;
      target.searchParams.delete('page');

      var targetHasStock = target.searchParams.has('filter.v.availability') || target.searchParams.has('integy_stock');
      if (!targetHasStock) {
        var currentMode = mode();
        if (indexedStockOwner(target) || clearanceCustomStockOwner(target)) {
          target.searchParams.delete('filter.v.availability');
          target.searchParams.set('integy_stock', currentMode);
        } else if (currentMode === 'out') {
          target.searchParams.set('filter.v.availability', '0');
        } else if (currentMode === 'all') {
          target.searchParams.set('integy_stock', 'all');
        } else {
          target.searchParams.set('filter.v.availability', '1');
        }
      }

      ['grid_list','sort_by'].forEach(function (key) {
        if (!target.searchParams.has(key) && current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
      });

      anchor.setAttribute('href', urlString(target));
      anchor.setAttribute('data-integy-v558-filter-state-link', 'true');
    } catch (error) {}
  }

  function normalizeFilterLinks(scope) {
    qa(filterLinkSelector, scope || document).forEach(normalizeFilterLink);
  }

  function restoreActions(scope) {
    qa('.integy-v547-direct-actions .productitem--action-trigger,.integy-v549-global-direct-actions .productitem--action-trigger,[data-integy-v547-direct-action]', scope || document).forEach(function (button) {
      if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
      if (button.getAttribute('aria-hidden') === 'true') button.removeAttribute('aria-hidden');
      if (button.tabIndex < 0) button.tabIndex = 0;
      button.setAttribute('data-integy-v558-a11y-restored', 'true');
    });
  }

  /* V567: V546 Boats contamination guard consolidated here so the old
     collection runtime can be retired. This preserves only the proven exclusion
     behavior and leaves stock/UI ownership to V567. */
  function removeBoatContaminants(scope) {
    var match = String(location.pathname || '').match(/\/collections\/([^/?#]+)/i);
    if (!match || decodeURIComponent(match[1]).toLowerCase() !== 'boats') return;
    qa('[data-product-item],.productgrid--item', scope || document).forEach(function (card) {
      var text = String(card.textContent || '').toLowerCase();
      var anchor = card.querySelector && card.querySelector('a[href*="/products/"]');
      var href = String(anchor && anchor.getAttribute('href') || '').toLowerCase();
      var sku = String(card.getAttribute('data-sku') || card.getAttribute('data-product-sku') || '').toUpperCase();
      var bad = sku === 'C29691' || href.indexOf('c29691') >= 0 || /\b(?:rock\s*)?crawler\b|\bmonster\s*truck\b|\btouring\s*car\b|\bdrift\s*car\b|\btruggy\b/.test(text);
      if (bad) card.remove();
    });
  }

  function visibleCards() {
    return qa('body.template-collection [data-productgrid-items] [data-product-item],body.template-collection [data-productgrid-items] .productgrid--item,body.template-collection .productgrid--items [data-product-item],body.template-collection .productgrid--items .productgrid--item').filter(function (card) {
      if (card.hidden || card.getAttribute('aria-hidden') === 'true') return false;
      var style = getComputedStyle(card);
      return style.display !== 'none';
    });
  }


  /* V565 native stock verifier/refill.
     Shopify's availability URL occasionally returns a card whose Liquid product
     state disagrees with the requested mode. Hide those cards immediately and,
     when possible, borrow matching cards from following native pages so a 72-card
     page does not collapse to a visibly sparse grid. Borrowed product paths are
     remembered per source page in sessionStorage so clicking Next does not repeat
     products that were already pulled forward. Indexed V501 grids are excluded;
     V501 performs live product-JSON verification itself. */
  var v567StockRefillState = { running: false, timer: 0, suppressMutations: false, fetches: Object.create(null) };

  function productPathFromCard(card) {
    var anchor = card && card.querySelector ? card.querySelector('a[href*="/products/"]') : null;
    if (!anchor) return '';
    try { return new URL(anchor.getAttribute('href') || '', location.origin).pathname.replace(/\/$/, ''); }
    catch (error) { return ''; }
  }

  function explicitCardAvailability(card) {
    if (!card) return null;
    var explicit = card.getAttribute('data-product-available');
    if (explicit === 'true') return true;
    if (explicit === 'false') return false;
    var stock = card.querySelector && card.querySelector('.integy-v426-card-stock,.productitem__stock-level');
    var text = String(stock && stock.textContent || '').toLowerCase();
    if (/sold\s*out|out\s*of\s*stock|unavailable/.test(text)) return false;
    if (/in\s*stock|available/.test(text)) return true;
    return null;
  }

  function nativeStockMatch(card, currentMode) {
    var available = explicitCardAvailability(card);
    if (available == null || currentMode === 'all') return true;
    return currentMode === 'out' ? !available : available;
  }

  function isIndexedGrid(grid) {
    if (!grid) return false;
    if (grid.hasAttribute('data-integy-v307-key')) return true;
    return !!grid.querySelector('[data-integy-v528-price-enrich="true"],[data-integy-v460-dynamic-card="canonical"]');
  }

  function currentNativePage() {
    var url = here();
    var page = url ? Number(url.searchParams.get('page') || 1) : 1;
    return isFinite(page) && page > 0 ? Math.floor(page) : 1;
  }

  function maxNativePage() {
    var maxPage = currentNativePage();
    qa('.pagination a[href*="page="],.pagination--container a[href*="page="],a.pagination--item[href*="page="]').forEach(function (anchor) {
      try {
        var page = Number(new URL(anchor.href, location.origin).searchParams.get('page') || 0);
        if (isFinite(page) && page > maxPage) maxPage = page;
      } catch (error) {}
    });
    return maxPage;
  }

  function stockBorrowBaseKey() {
    var url = here();
    if (!url) return '';
    url.searchParams.delete('page');
    return 'integy:v567:stock-borrow:' + url.pathname + '?' + url.searchParams.toString();
  }

  function readBorrowState() {
    var key = stockBorrowBaseKey();
    if (!key) return { key: '', data: { ts: Date.now(), pages: {} } };
    try {
      var raw = sessionStorage.getItem(key);
      var data = raw ? JSON.parse(raw) : null;
      if (!data || !data.pages || !data.ts || Date.now() - data.ts > 30 * 60 * 1000) data = { ts: Date.now(), pages: {} };
      return { key: key, data: data };
    } catch (error) { return { key: key, data: { ts: Date.now(), pages: {} } }; }
  }

  function writeBorrowState(state) {
    if (!state || !state.key) return;
    state.data.ts = Date.now();
    try { sessionStorage.setItem(state.key, JSON.stringify(state.data)); } catch (error) {}
  }

  function pageSkipSet(state, page) {
    var map = Object.create(null);
    var list = state && state.data && state.data.pages && state.data.pages[String(page)] || [];
    list.forEach(function (path) { map[path] = true; });
    return map;
  }

  function rememberBorrow(state, sourcePage, path) {
    if (!state || !path) return;
    var key = String(sourcePage);
    var list = state.data.pages[key] || (state.data.pages[key] = []);
    if (list.indexOf(path) < 0) list.push(path);
  }

  function fetchNativePage(page) {
    var url = here();
    if (!url) return Promise.resolve(null);
    url.searchParams.set('page', String(page));
    var key = urlString(url);
    if (v567StockRefillState.fetches[key]) return v567StockRefillState.fetches[key];
    v567StockRefillState.fetches[key] = fetch(key, { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (response) { if (!response.ok) throw new Error('V565 refill page unavailable'); return response.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function () { return null; });
    return v567StockRefillState.fetches[key];
  }

  function nativeCardsFromDocument(doc) {
    if (!doc) return [];
    var grid = doc.querySelector('[data-productgrid-items],.productgrid--items');
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll('[data-product-item],.productgrid--item'));
  }

  function updateNativeStockStatus(grid, currentMode) {
    /* V681: once the large-collection owner is active, its result total and
       page-slice status are authoritative. Do not let the legacy native verifier
       overwrite "72/43 of 115" with a page-local card count. */
    if (largeDemandOwnerActive()) return;
    var visible = qa('[data-product-item],.productgrid--item', grid).filter(function (card) { return !card.hidden && card.getAttribute('aria-hidden') !== 'true'; }).length;
    var nextText = visible + ' live ' + (currentMode === 'out' ? 'out-of-stock' : 'in-stock') + ' match' + (visible === 1 ? '' : 'es') + ' on this page';
    var nextCount = String(visible);
    qa('[data-integy-v449-stock-status]').forEach(function (status) {
      /* INTEGY V609 — do not rewrite an unchanged live-stock summary. Replacing
         the text node used to wake the global MutationObserver, which scheduled
         another stock pass and could repeatedly reflow the Sort By toolbar. */
      if (status.textContent !== nextText) status.textContent = nextText;
      if (status.getAttribute('data-integy-v567-live-page-count') !== nextCount) {
        status.setAttribute('data-integy-v567-live-page-count', nextCount);
      }
    });
  }

  function collectNativeStock(needed, currentMode, state, seen, sourcePage, maxPage, collected) {
    collected = collected || [];
    if (needed <= 0 || sourcePage > maxPage) return Promise.resolve(collected);
    return fetchNativePage(sourcePage).then(function (doc) {
      if (!doc) return collectNativeStock(needed, currentMode, state, seen, sourcePage + 1, maxPage, collected);
      var skip = pageSkipSet(state, sourcePage);
      var candidates = nativeCardsFromDocument(doc);
      for (var i = 0; i < candidates.length && needed > 0; i += 1) {
        var card = candidates[i];
        var path = productPathFromCard(card);
        if (!path || seen[path] || skip[path] || !nativeStockMatch(card, currentMode)) continue;
        seen[path] = true;
        rememberBorrow(state, sourcePage, path);
        var clone = document.importNode(card, true);
        clone.setAttribute('data-integy-v567-stock-refill', 'true');
        clone.setAttribute('data-integy-v567-stock-source-page', String(sourcePage));
        collected.push(clone);
        needed -= 1;
      }
      if (needed > 0) return collectNativeStock(needed, currentMode, state, seen, sourcePage + 1, maxPage, collected);
      return collected;
    });
  }

  function releasePendingVisuals() {
    root.classList.remove('integy-v567-stock-pending','integy-v567-filter-pending','integy-v566-stock-pending','integy-v566-filter-pending');
    if (window.INTEGY_V566_VISUAL_FAILSAFE) { clearTimeout(window.INTEGY_V566_VISUAL_FAILSAFE); window.INTEGY_V566_VISUAL_FAILSAFE = 0; }
  }

  function indexedGridSettled() {
    var grid = document.querySelector('[data-productgrid-items],.productgrid--items');
    if (!grid || !isIndexedGrid(grid)) return false;
    return !grid.querySelector('[data-integy-v548-stock-verified="false"]');
  }

  function releaseIndexedWhenStable(tries) {
    tries = Number(tries || 0);
    if (indexedGridSettled() || tries >= 100) { releasePendingVisuals(); return; }
    setTimeout(function () { releaseIndexedWhenStable(tries + 1); }, 40);
  }

  function customIndexedFilterRequested() {
    var url = here();
    if (!url) return false;
    return !!(url.searchParams.get('integy_filter') || url.searchParams.get('integy_filters') || url.searchParams.get('integy_tag_filter'));
  }

  function verifyNativeStockCards() {
    if (!isCollection()) { releasePendingVisuals(); return; }
    if (largeDemandOwnerActive()) { releasePendingVisuals(); return; }
    /* V566: never expose or mutate Shopify's native grid while a V501 indexed
       filter is requested. V501 will replace that grid authoritatively; the
       head-level pending class remains until its analytics render signal. */
    if (customIndexedFilterRequested()) { releaseIndexedWhenStable(0); return; }
    var currentMode = mode();
    if (currentMode === 'all') { releasePendingVisuals(); return; }
    var grid = document.querySelector('[data-productgrid-items],.productgrid--items');
    if (!grid || v567StockRefillState.running) return;
    /* INTEGY V606 — Shopify-native availability collections (for example
       RC Electronics and RC Tools) already arrive server-filtered. Do not run
       the legacy borrow/refill pass on those pages: that pass can change grid
       height after first paint and is the source of visible flashing/jumping.
       Keep the conservative verifier only on the narrowly audited indexed-stock
       universes where Shopify native availability is known to be unreliable. */
    if (!indexedStockOwner(here())) {
      updateNativeStockStatus(grid, currentMode);
      releasePendingVisuals();
      return;
    }
    if (isIndexedGrid(grid)) { releaseIndexedWhenStable(0); return; }
    var cards = qa('[data-product-item],.productgrid--item', grid);
    if (!cards.length) { releasePendingVisuals(); return; }

    v567StockRefillState.running = true;
    grid.classList.add('integy-v567-native-stock-verifying');
    grid.setAttribute('aria-busy', 'true');
    var page = currentNativePage();
    var maxPage = maxNativePage();
    var state = readBorrowState();
    var skip = pageSkipSet(state, page);
    var seen = Object.create(null);
    var storedTarget = Number(grid.getAttribute('data-integy-v567-stock-target') || 0);
    var nativeCards = cards.filter(function (card) { return card.getAttribute('data-integy-v567-stock-refill') !== 'true'; });
    var target = storedTarget > 0 ? storedTarget : nativeCards.length;
    if (!storedTarget && target > 0) grid.setAttribute('data-integy-v567-stock-target', String(target));

    var keep = [];
    var hide = [];
    cards.forEach(function (card) {
      var path = productPathFromCard(card);
      if (path) seen[path] = true;
      if ((path && skip[path]) || !nativeStockMatch(card, currentMode)) hide.push(card);
      else keep.push(card);
    });
    var needed = Math.max(0, target - keep.length);

    collectNativeStock(needed, currentMode, state, seen, page + 1, maxPage, []).then(function (collected) {
      writeBorrowState(state);
      var commit = function () {
        v567StockRefillState.suppressMutations = true;
        hide.forEach(function (card) {
          card.hidden = true;
          card.setAttribute('aria-hidden', 'true');
          card.setAttribute('data-integy-v567-stock-verified', 'true');
        });
        keep.forEach(function (card) {
          card.hidden = false;
          card.removeAttribute('aria-hidden');
          card.setAttribute('data-integy-v567-stock-verified', 'true');
        });
        if (collected && collected.length) {
          var fragment = document.createDocumentFragment();
          collected.forEach(function (card) { fragment.appendChild(card); });
          grid.appendChild(fragment);
        }
        grid.classList.remove('integy-v567-native-stock-verifying');
        grid.setAttribute('data-integy-v567-native-stock-verified', 'true');
        grid.removeAttribute('aria-busy');
        restoreActions(grid);
        updateNativeStockStatus(grid, currentMode);
        releasePendingVisuals();
        v567StockRefillState.running = false;
        setTimeout(function () { v567StockRefillState.suppressMutations = false; }, 180);
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(commit); else commit();
    }).catch(function () {
      /* Even if later pages cannot be fetched, commit the correct stock subset once. */
      var commitFallback = function () {
        v567StockRefillState.suppressMutations = true;
        hide.forEach(function (card) { card.hidden = true; card.setAttribute('aria-hidden', 'true'); card.setAttribute('data-integy-v567-stock-verified', 'true'); });
        keep.forEach(function (card) { card.hidden = false; card.removeAttribute('aria-hidden'); card.setAttribute('data-integy-v567-stock-verified', 'true'); });
        grid.classList.remove('integy-v567-native-stock-verifying');
        grid.removeAttribute('aria-busy');
        updateNativeStockStatus(grid, currentMode);
        releasePendingVisuals();
        v567StockRefillState.running = false;
        setTimeout(function () { v567StockRefillState.suppressMutations = false; }, 180);
      };
      if (window.requestAnimationFrame) window.requestAnimationFrame(commitFallback); else commitFallback();
    });
  }

  function scheduleNativeStockVerification(delay) {
    clearTimeout(v567StockRefillState.timer);
    v567StockRefillState.timer = setTimeout(verifyNativeStockCards, delay == null ? 80 : delay);
  }

  /* V677: the V651/V672+ large-stock owner intentionally keeps the requested
     deep-page URL while it fetches the next 100-product source slice. The old
     V568 empty-page rescue must never delete ?page=2/?page=3 during that pause.
     Check both before scheduling and again inside the timer because the large
     owner may initialize after this legacy owner but before the 950ms repair. */
  function largeDemandOwnerActive() {
    if (window.IntegyV651LargeStockOwnerActive ||
        window.IntegyV681LargeCollectionStockOwner ||
        window.IntegyV651LargeCollectionStockOwner ||
        window.IntegyV677LargeCollectionStockOwner ||
        window.IntegyV668LargeCollectionStockOwner ||
        window.IntegyV671LargeCollectionStockOwner ||
        window.IntegyV672LargeCollectionStockOwner ||
        window.IntegyV673LargeCollectionStockOwner ||
        window.IntegyV674LargeCollectionStockOwner ||
        window.IntegyV675LargeCollectionStockOwner ||
        window.IntegyV677LargeCollectionStockOwner) return true;
    if (root.classList.contains('integy-v651-large-stock-loading') ||
        root.classList.contains('integy-v651-large-stock-ready') ||
        root.classList.contains('integy-v664-demand-ready')) return true;
    return !!document.querySelector('[data-integy-v651-large-owner],[data-integy-v651-large-loading]');
  }

  function repairDeepPage() {
    if (!isCollection() || largeDemandOwnerActive()) return;
    var url = here();
    var page = url ? Number(url.searchParams.get('page') || 1) : 1;
    if (!url || !isFinite(page) || page <= 1) return;
    setTimeout(function () {
      if (largeDemandOwnerActive()) return;
      if (visibleCards().length) return;
      var noResults = document.querySelector('.productgrid--no-results,.integy-v426-empty-state');
      var active = /[?&](?:integy_filter|integy_filters|integy_tag_filter|filter\.v\.availability|integy_stock)=/i.test(location.search || '');
      if (!active && !noResults) return;
      url.searchParams.delete('page');
      root.classList.add('integy-v558-page-repair', 'integy-v556-page-repair');
      location.replace(urlString(url));
    }, 950);
  }

  function navClick(event) {
    var anchor = event.target && event.target.closest ? event.target.closest('a[href*="/collections/"]') : null;
    if (anchor && anchor.closest(navScope)) normalizeLink(anchor);
  }

  function filterClick(event) {
    var anchor = event.target && event.target.closest ? event.target.closest(filterLinkSelector) : null;
    if (anchor) normalizeFilterLink(anchor);
  }

  if (canonicalizeLegacyAllRoute()) return;

  function boot() {
    root.classList.add('integy-v558','integy-v558-ready','integy-v567-collection-state-ready','integy-v564-collection-state-ready','integy-direct-commerce');
    normalizeStockUrl();
    syncStock();
    scaleSweep();
    normalizeNav(document);
    normalizeFilterLinks(document);
    restoreActions(document);
    removeBoatContaminants(document);
    scheduleNativeStockVerification(20);
    repairDeepPage();
    document.addEventListener('click', stockClick, true);
    document.addEventListener('click', navClick, true);
    document.addEventListener('click', filterClick, true);
    document.addEventListener('integy:analytics', function (event) {
      var detail = event && event.detail || {};
      if (detail.event === 'integy:v429:filter-rendered') releaseIndexedWhenStable(0);
    });

    if (window.MutationObserver) {
      var timer = 0;
      new MutationObserver(function (mutations) {
        if (v567StockRefillState.suppressMutations) return;
        /* INTEGY V609 — live stock summary updates are informational only. Ignore
           child/text nodes added inside that status node so the observer cannot
           feed its own update back into another verification/reflow cycle. */
        var relevantMutation = mutations.some(function (mutation) {
          if (!mutation.addedNodes || !mutation.addedNodes.length) return false;
          var target = mutation.target;
          if (target && target.nodeType === 1 && target.closest && target.closest('[data-integy-v449-stock-status]')) return false;
          return true;
        });
        if (!relevantMutation) return;
        clearTimeout(timer);
        timer = setTimeout(function () {
          syncStock();
          scaleSweep();
          normalizeNav(document);
          normalizeFilterLinks(document);
          restoreActions(document);
          removeBoatContaminants(document);
          scheduleNativeStockVerification(40);
        }, 80);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  var api = {
    version: 'V675',
    modeFromUrl: mode,
    stockUrl: stockUrl,
    sync: syncStock,
    scaleSweep: scaleSweep,
    normalizeNav: normalizeNav,
    normalizeFilterLinks: normalizeFilterLinks,
    repairDeepPage: repairDeepPage,
    verifyNativeStockCards: verifyNativeStockCards
  };
  window.IntegyV568CollectionState = api;
  window.IntegyV567CollectionState = api;
  window.IntegyV566CollectionState = api;
  window.IntegyV565CollectionState = api;
  window.IntegyV564CollectionState = api;
  window.IntegyV562CollectionState = window.IntegyV562CollectionState || api;
  window.IntegyV558CollectionState = api;
  window.IntegyV556CollectionState = window.IntegyV556CollectionState || api;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());

